export const isLocalEnvironment = () => {
  return process.env.REACT_APP_ENV === 'local';
};

export const isProductionEnvironment = () => {
  return process.env.REACT_APP_VERCEL_ENV === 'production';
};
